<template>
  <el-dialog
    class="database_creator"
    title="创建数据库"
    width="540px"
    top="25vh"
    :close-on-click-modal="false"
    :visible.sync="isVisible"
    @closed="onDialogClosed"
  >
    <el-form label-width="108px" ref="form" :model="form" :rules="rules">
      <el-form-item label="数据库名称" prop="databaseName">
        <el-input class="full-width" v-model="form.databaseName"></el-input>
      </el-form-item>
      <el-form-item label="字符集" prop="characterSet">
        <el-select class="full-width" v-model="form.characterSet" @change="characterChange">
          <el-option
            v-for="(item,index) in characterCollection"
            :key="index"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="校验规则" prop="checkRule">
        <el-select class="full-width" v-model="form.checkRule">
          <el-option
            v-for="(item, index) in checkRuleOption"
            :key="index"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>

    <div slot="footer">
      <el-button @click="isVisible = false">关闭</el-button>
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { reqCharacters, reqExecSql } from '@/api/jdbc';
import Validator from '@/utils/Validator';

export default {
  name: 'DatabaseCreator',

  data() {
    const dbRule = (rule, value, callback) => {
      const validator = new Validator(rule, value, callback);
      validator
        /*.register(validator.isStandardStr())
        .register(validator.lenRange(1, 65, `数据库名的长度不能超过 64 个字符`))*/
        .validate();
    };

    return {
      isVisible: false,
      form: {
        databaseName: '',
        characterSet: '',
        checkRule: ''
      },
      rules: {
        databaseName: [
          { required: true, message: '请输入数据库名称', trigger: 'blur' },
          { validator: dbRule, trigger: 'blur' }
        ]
      },
      characterCollection: [],
      checkRuleOption: [],
      checkRuleOptionAll: {}
    };
  },

  methods: {
    async open() {
      this.isVisible = true;
      try{
        const res = await reqCharacters();
        //const res = await reqExecSql();
        this.characterCollection = [{ label: 'default character set', value: 'default character set'}];
        this.checkRuleOptionAll['default character set'] = [];
        res.data.data.map((item)=>{
          let obj = {
            label: `${item.CHARACTER_SET_NAME}--${item.DESCRIPTION.replace(/\s/g,'|')}`,
            value: item.CHARACTER_SET_NAME
          };
          this.characterCollection.push(obj);
          /*let obj1 = {
            [item.CHARACTER_SET_NAME]:
          }*/
          this.checkRuleOptionAll[item.CHARACTER_SET_NAME] = item.COLLATIONS.map(item=>item.COLLATION_NAME);
        });
        this.form.characterSet = 'default character set';
        this.checkRuleOption = [];
        //console.log(this.checkRuleOptionAll)
      } catch (e) {
        this.$message.error('获取字符集失败');
      }

    },
    onDialogClosed() {
      this.form.databaseName = '';
      this.$refs.form.resetFields();
    },
    onSubmit() {
      this.$refs.form.validate(async valid => {
        if (!valid) {
          this.$message.warning('请完成所有表单项');
          return;
        }

        try {
          let sqlStr = `create database ${this.form.databaseName} `;
          if(this.form.characterSet !== 'default character set')
          {
            sqlStr += `character set ${this.form.characterSet} collate ${this.form.checkRule}`
          }
          const res = await reqExecSql(sqlStr);
          if(res.data.data.Result[0].Error)
          {
            this.$message.error(res.data.data.Result[0].Error.Message);
            return;
          }
          this.$message.success('创建成功');
          this.isVisible = false;
          this.$emit('submit', true);
        } catch (e) {
          this.$message.error('创建失败');
          this.$emit('submit', false);
        }
      });
    },
    resetForm() {
      this.$refs.form.resetFields();
      this.form.databaseName = '';
    },
    characterChange(){
      this.checkRuleOption = this.checkRuleOptionAll[this.form.characterSet];
      if(this.checkRuleOption.length > 0){
        this.form.checkRule = this.checkRuleOption[0];
      }
      else{
        this.form.checkRule = '';
      }

    }
  }
};
</script>
